module.exports = __webpack_public_path__ + "img/arrow-left.f2912943.svg";